import { handleActions } from 'redux-actions'
import _ from 'lodash'

import {
  SET_FORMS_AND_DEPENDENCIES,
  LOGOUT,
  FORM_CLEAN_FORM,
  FORM_SELECT_FORM,
  FORM_SELECT_POINT_START,
  FORM_SELECT_POINT_SUCCEEDED,
  FORM_SELECT_POINT_ERROR,
  FORM_ADD_QUESTIONS_VALUE,
  FORM_SET_STAGE_START,
  FORM_SET_STAGE_SUCCEEDED,
  FORM_SET_STAGE_ERROR,
  FORM_SET_STAGE_FINALLY,
  FORM_SET_QUESTIONS_VALUE,
  FINALIZE_FORM_START,
  FINALIZE_FORM_SUCCEEDED,
  FINALIZE_FORM_ERROR,
  FINALIZE_FORM_FINALLY,
  FORM_DETAIL_START,
  FORM_DETAIL_SUCCEEDED,
  FORM_DETAIL_ERROR,
  FORM_SET_START_FORM,
  FORM_SET_PENDING_SUCCEEDED,
  FORM_SET_STEP,
} from '../../actions'

const initialState = {
  forms: [],
  stages: [],
  funnels: [],
  funnelsStages: [],
  questionsGroups: [],
  questions: [],
  formsPoints: [],
  submissions: [],
  formSelected: null,
  pointSelected: null,
  stageSelected: null,
  abstractQuestionsGroup: [],
  questionsValue: {},
  finalizeForm: false,
  loading: false,
  formError: null,
  ending: false,
  searchDetails: false,
  startFormDate: null,
  formPointPending: null,
  steps: 3,
  activeStep: 1,
}

const findRecursive = (allQuestionGroupsKeyed, id, questionId, questionIds = []) => {
  const parent = allQuestionGroupsKeyed[id] || {}

  if (parent.questionGroupRef) {
    return findRecursive(
      allQuestionGroupsKeyed,
      parent.questionGroupRef,
      questionId,
      [...questionIds, parent.question_id],
    )
  }

  return [...questionIds, parent.question_id]
}

const compareAbstractQuestionsGroup = (state, payload) => {
  const {
    abstractQuestionsGroup,
    questionsValue,
    finalizeForm,
    stageSelected,
  } = state
  const {
    questionGroupId,
    value,
    question_id,
    abstractQuestionGroupId,
    finalize,
    stage_id,
  } = payload

  const abstractQuestionsGroupKeyed = _.keyBy(abstractQuestionsGroup, 'questionGroupId')
  const questionsToDelete = findRecursive(abstractQuestionsGroupKeyed, questionGroupId, question_id)
  const questionNotDelete = _.reduce(abstractQuestionsGroup, (acum, abstract) => {
    if (abstract.questionGroupId === questionGroupId && abstract.question_id !== question_id) {
      return acum.concat(abstract.question_id)
    }

    return acum
  }, [])
  const questionsIdToDelete = _.filter(
    questionsToDelete,
    question => !questionNotDelete.includes(question),
  )

  return {
    abstractQuestionsGroup: abstractQuestionsGroup
      .filter(abstract =>
        !questionsIdToDelete
          .concat(question_id)
          .includes(abstract.question_id))
      .concat({
        question_id,
        questionGroupId,
        questionGroupRef: abstractQuestionGroupId,
      }),
    questionsValue: {
      ..._.omit(questionsValue, questionsIdToDelete),
      [question_id]: {
        value,
        questionGroupId,
      },
    },
    finalizeForm: typeof finalize === 'boolean'
      ? finalize
      : finalizeForm,
    stageSelected: stage_id || stageSelected,
  }
}

export default handleActions({
  [SET_FORMS_AND_DEPENDENCIES]: (state, action) => {
    const {
      forms,
      stages,
      funnels,
      funnelsStages,
      questionsGroups,
      questions,
      formsPoints,
    } = action.payload

    return {
      ...state,
      forms,
      stages,
      funnels,
      funnelsStages,
      questionsGroups,
      questions,
      formsPoints,
    }
  },
  [FORM_SELECT_FORM]: (state, action) => ({
    ...state,
    formSelected: action.payload,
    stageSelected: null,
    abstractQuestionsGroup: [],
    questionsValue: {},
    finalizeForm: false,
    formError: null,
    loading: false,
    ending: false,
    searchDetails: false,
    startFormDate: null,
    formPointPending: null,
  }),
  [FORM_SELECT_POINT_START]: state => ({
    ...state,
    pointSelected: { loading: true },
  }),
  [FORM_SELECT_POINT_SUCCEEDED]: (state, action) => ({
    ...state,
    pointSelected: action.payload.point,
  }),
  [FORM_SELECT_POINT_ERROR]: (state, action) => ({
    ...state,
    pointSelected: {
      ...state.pointSelected,
      error: action.payload,
    },
  }),
  [FORM_SET_STEP]: (state, action) => ({
    ...state,
    activeStep: action.payload,
  }),
  [FORM_SET_QUESTIONS_VALUE]: (state, action) => {
    return {
      ...state,
      questionsValue: action.payload,
    }
  },
  [FORM_ADD_QUESTIONS_VALUE]: (state, action) => {
    const {
      abstractQuestionsGroup,
      questionsValue,
      finalizeForm,
      stageSelected,
    } = compareAbstractQuestionsGroup(state, action.payload)

    return {
      ...state,
      abstractQuestionsGroup,
      questionsValue,
      finalizeForm,
      stageSelected,
    }
  },
  [FORM_SET_STAGE_START]: state => ({
    ...state,
    loading: true,
  }),
  [FORM_SET_STAGE_SUCCEEDED]: (state, action) => ({
    ...state,
    stageSelected: action.payload,
  }),
  [FORM_SET_STAGE_ERROR]: (state, action) => ({
    ...state,
    formError: action.payload,
  }),
  [FORM_SET_STAGE_FINALLY]: state => ({
    ...state,
    loading: null,
  }),
  [FINALIZE_FORM_START]: state => ({
    ...state,
    ending: true,
  }),
  [FINALIZE_FORM_SUCCEEDED]: (state, action) => ({
    ...state,
    formsPoints: state.formsPoints
      .filter(formpoint => formpoint._id !== action.payload.formsPoints._id)
      .concat(action.payload.formsPoints),
    submissions: state.submissions.concat(action.payload.submissions),
    formSelected: null,
    pointSelected: null,
    stageSelected: null,
    abstractQuestionsGroup: [],
    questionsValue: {},
    finalizeForm: false,
    loading: false,
    formError: null,
    startFormDate: null,
    activeStep: 1,
  }),
  [FINALIZE_FORM_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
  }),
  [FINALIZE_FORM_FINALLY]: state => ({
    ...state,
    ending: false,
  }),
  [FORM_DETAIL_START]: state => ({
    ...state,
    searchDetails: true,
  }),
  [FORM_DETAIL_SUCCEEDED]: (state, action) => ({
    ...state,
    searchDetails: false,
    submissions: state.submissions.concat(action.payload),
  }),
  [FORM_DETAIL_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
    searchDetails: false,
  }),
  [FORM_SET_START_FORM]: (state, action) => ({
    ...state,
    startFormDate: state.startFormDate || action.payload,
  }),
  [FORM_SET_PENDING_SUCCEEDED]: (state, { payload }) => ({
    ...state,
    formSelected: payload.formSelected,
    stageSelected: payload.stageSelected,
    pointSelected: payload.pointSelected,
    startFormDate: payload.created_at,
    formPointPending: payload.formPointPending,
    abstractQuestionsGroup: [],
    questionsValue: {},
    finalizeForm: false,
    formError: null,
    loading: false,
    ending: false,
    searchDetails: false,
  }),
  [FORM_CLEAN_FORM]: (state, action) => ({
    ...state,
    formSelected: null,
    pointSelected: null,
    stageSelected: null,
    abstractQuestionsGroup: [],
    questionsValue: {},
    finalizeForm: false,
    formError: null,
    loading: false,
    ending: false,
    searchDetails: false,
    startFormDate: null,
    formPointPending: null,
    activeStep: 1,
  }),
  [LOGOUT]: () => initialState,
}, initialState)
